import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import { GrAttachment } from "react-icons/gr";
import { IoAddOutline } from "react-icons/io5";
import CustomModal from "../../Components/CustomModal";
import Loading from "../../Components/Loading";
import { ToDateJalali, ToTimeJalali } from "../../Utils/functions";
import { useChat, useSupport } from "./Hooks";
const Support = () => {
  const { handler, toggle, form, send, loading, data, render } = useSupport();
  return (
    <div className="row">
      <div className="col-3 col-sm-4 tickets">
        {loading.get ? (
          <Loading height={"100px"} count={3} />
        ) : (
          <>
            {data?.data?.length == 0 ? (
              <div className="d-flex justify-content-center align-items-center h-100">
                <p>تیکتی یافت نشد!</p>
              </div>
            ) : (
              data?.data?.map(ticket => {
                return (
                  <div
                    className={`ticket ${
                      form?.selected?.id == ticket.id ? "ticket-active" : ""
                    }`}
                    key={ticket.id}
                    onClick={() => {
                      handler("selected", ticket);
                    }}
                  >
                    <div className="ticket-icon d-lg-block d-none">
                      <img src={require("../../Assets/images/logo.png")} />
                    </div>
                    <div className="ticket-content">
                      <h4 className="fs-15">پشتیبانی</h4>
                      <p className="fs-10">{ticket.title}</p>
                    </div>
                    <div className="ticket-time">
                      <span className="fs-10 fw-300">
                        {ToDateJalali(ticket.created_at)}
                      </span>
                      <div>{render(ticket.status)}</div>
                    </div>
                  </div>
                );
              })
            )}
          </>
        )}
        <button className="new-ticket" onClick={toggle}>
          <IoAddOutline />
        </button>
        <CustomModal
          show={form.show}
          handleClose={toggle}
          header="تیکت جدید"
          size={"md"}
        >
          <div className="profile">
            <div className="row">
              <div className="col-12">
                {" "}
                <label className="form-label" htmlFor="first-name">
                  عنوان
                </label>
                <input
                  className="form-control"
                  id="first-name"
                  type="text"
                  onChange={({ target: { value } }) => {
                    handler("title", value);
                  }}
                />
              </div>
              <div className="col-12">
                {" "}
                <label className="form-label" htmlFor="first-name">
                  توضیحات
                </label>
                <textarea
                  className="form-control"
                  id="first-name"
                  type="text"
                  onChange={({ target: { value } }) => {
                    handler("description", value);
                  }}
                ></textarea>
              </div>
              <div className="col-12">
                {" "}
                <label className="form-label" htmlFor="email2">
                  دپارتمان
                </label>
                <select
                  className="form-control mb-2"
                  id="email2"
                  type="text"
                  onChange={({ target: { value } }) => {
                    handler("departman_id", value);
                  }}
                >
                  <option>انتخاب کنید</option>
                  <option value={"sale"}>فروش</option>
                  <option value={"technical"}>فنی</option>
                  <option value={"Financial"}>مالی</option>
                  <option value={"experts"}>فروشنده</option>
                </select>
              </div>
              <div className="col-12">
                <button className="btn btn-danger w-100" onClick={send}>
                  {loading.send ? <Spinner /> : "ارسال"}
                </button>
              </div>
            </div>
          </div>
        </CustomModal>
      </div>

      <Chat data={form.selected} toggle={toggle} />
    </div>
  );
};
const Chat = ({ data, toggle }) => {
  const { messagesEndRef, chat, loading, send, handler, form } = useChat({
    inintial: data,
  });

  if (data?.id) {
    return (
      <div className="col-9 chat col-sm-8">
        <div className="chat-container">
          {loading.get ? (
            <div className="m-2">
              <Loading count={8} height={40} />
            </div>
          ) : (
            <div>
              {chat.messages.map(message => {
                if (message.type == "question") {
                  return (
                    <div className="d-flex p-2">
                      <div className="flex-1">
                        <div className="w-xxl-75">
                          <div className="hover-actions-trigger d-flex align-items-center">
                            <div className="chat-message bg-200 p-2 rounded-2">
                              {message.message}
                            </div>
                          </div>
                          <div className="text-400 fs--2">
                            <span>{ToTimeJalali(message.created_at)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div className="w-100 w-xxl-75">
                      <div className="hover-actions-trigger d-flex flex-end-center">
                        <div className="bg-primary text-white p-2 rounded-2 chat-message light">
                          {message.message}
                        </div>
                      </div>
                      <div className="text-400 fs--2 text-end">
                        <span>{ToTimeJalali(message.created_at)}</span>
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          )}
          {/* {Array(200)
            .fill(1)
            .map(d => (
              <div>d</div>
            ))} */}
          <div ref={messagesEndRef} />
        </div>
        <div className="send-message">
          <button>
            <GrAttachment />
          </button>
          <input
            placeholder="پیام جدید"
            onChange={({ target: { value } }) => {
              handler("message", value);
            }}
            value={form.message}
            onKeyDown={e => {
              if (e.key == "Enter") {
                send();
              }
            }}
          />
          <button className="btn btn-danger" onClick={send}>
            {loading.send ? <Spinner /> : "ارسال"}
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="col-9 chat col-sm-8">
      <div className="chat-container d-flex justify-content-center align-items-center">
        <div>
          <p className="fs-15">لطفا تیکت مورد نظر را انتخاب کنید</p>
          <p className="text-center fs-12">
            یا
            <a className="link pointer" onClick={toggle}>
              {" "}
              تیکت جدید{" "}
            </a>
            باز کنید
          </p>
          <a></a>
        </div>
      </div>
    </div>
  );
};
export default Support;
